import React, { createContext, useContext } from 'react'
import { Platform, View, type ViewProps } from 'react-native'
import { useTheme } from '../../hooks/useTheme'
import { TEAMMATE_WARNING_COLORS, TURN_PANEL_COLORS, turnCardStyle } from '../../lib/turnPanelAppearance'

/** The game container supplies its established desktop breakpoint. */
export const TurnPanelDesktopContext = createContext(false)
export const useTurnPanelDesktop = () => useContext(TurnPanelDesktopContext)

export function TurnControlCard({ children, style, className, accent, ...props }: ViewProps & { accent?: 'blood' | 'transfer' | 'warning' }) {
  const { theme } = useTheme()
  const isDesktop = useTurnPanelDesktop()
  const accentColor = accent === 'blood' ? (theme === 'dark' ? '#e0463f' : '#b82020')
    : accent === 'transfer' ? (theme === 'dark' ? '#fbbf24' : '#b45309')
    : accent === 'warning' ? TEAMMATE_WARNING_COLORS[theme].accent : undefined
  return <View testID="turn-control-card" {...props}
    className={`${className ?? ''}${accent ? ` turn-card-${accent}` : ''}`}
    style={[
      turnCardStyle(theme, isDesktop),
      Platform?.OS === 'web' ? { boxShadow: `inset 0 1px 0 ${TURN_PANEL_COLORS[theme].highlight}` } : undefined,
      accentColor ? { borderColor: accentColor } : undefined,
      style,
    ]}>{children}</View>
}
